import React from "react";
import moment from "moment";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect, Dispatch } from "react-redux";
import {
    RouteProps,
    Redirect,
    RouterProps,
    RouteComponentProps,
} from "react-router";
import {
    Grid,
    Typography,
    ListItem,
    WithStyles,
    withStyles,
    Divider,
    List,
} from "material-ui";
import { SetShowBackNavigation } from "ducks/common";
import { getCreditCardById } from "ducks/creaditcard";
import { CreditCardDetailsDto } from "util/DTOs/CreditCardDtos";
import AlternatingCardDetailsList from "components/AlternatingCardDetailsList";
import { formatNumber } from "util/utils";
import mcLogo from "./mc_symbol.svg";
import { autoCompletePostalCity } from "ducks/postalcodes";

const styles = {
    container: {
        padding: 0,
    },
    content: {
        height: "100%",
        padding: 0,
        position: "relative",
    },
    subheadingWeight: {
        fontWeight: "200",
    },
    centerText: {
        textAlign: "center",
    },
    rightText: {
        textAlign: "right",
    },
    flexRoot: {
        display: "flex",
        width: "calc(100% - 30px)",
        flexGrow: 1,
    },
    flexItem: {
        flex: 1,
        whiteSpace: "nowrap",
        wordWrap: "break-word",
    },
} as React.CSSProperties;

interface ICreditCardDetailsPageStateProps {
    details?: CreditCardDetailsDto;
}
interface ICreditCardDetailsPageDispatchProps {
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
    GetCardDetails: (id: string) => Promise<void>;
}

interface ICreditCardDetailsPageProps {
    id: string;
}

type CreditCardDetailsPageProps = ICreditCardDetailsPageProps &
    ICreditCardDetailsPageDispatchProps &
    ICreditCardDetailsPageStateProps &
    RouterProps &
    RouteProps;

type CreditCardDetailsPagePropsWithStyles = CreditCardDetailsPageProps &
    WithStyles<
        | "container"
        | "content"
        | "subheadingWeight"
        | "centerText"
        | "rightText"
        | "flexRoot"
        | "flexItem"
    >;

class CreditCardDetailsPage extends React.Component<
    CreditCardDetailsPagePropsWithStyles
> {
    componentDidMount() {
        this.props.ShowBackNavigation();
        this.props.GetCardDetails(this.props.id);
    }

    componentWillUnmount() {
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="CreditCardDetailsPage">
                {this.props.details && (
                    <Grid container spacing={0} style={{ padding: 16 }}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            width: 198,
                                            marginLeft: "auto",
                                            marginRight: "auto",
                                        }}
                                    >
                                        <Typography
                                            variant="title"
                                            style={{
                                                textAlign: "center",
                                                color: "#004170",
                                            }}
                                        >
                                            {
                                                this.props.details.card
                                                    .productName
                                            }
                                        </Typography>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            src={mcLogo}
                                            alt="Master Card"
                                            style={{
                                                maxHeight: 42,
                                                paddingTop: 4,
                                                paddingBottom: 4,
                                                width: "auto",
                                            }}
                                        />
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Typography
                                                variant="subheading"
                                                style={{ color: "#004170" }}
                                            >
                                                {this.props.details &&
                                                    `${this.formatCardNumber(
                                                        this.props.details.card
                                                            .truncatedCardNumber
                                                    ).replace(/\*/g, "•")}`}
                                            </Typography>
                                            <Typography
                                                gutterBottom
                                                style={{ color: "#004170" }}
                                            >
                                                {this.props.details &&
                                                    `${moment(
                                                        this.props.details.card
                                                            .cardExpiryDate
                                                    ).format("MM/YY")}`}
                                            </Typography>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: 8 }}>
                            <Divider />
                        </Grid>
                        <Grid item xs={6}>
                            <Typography style={{ fontWeight: "bold" }}>
                                Saldo:
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography style={{ fontWeight: "bold" }}>
                                {this.props.details &&
                                    `${formatNumber(
                                        this.props.details.account
                                            .accountBalance,
                                        2
                                    )} ${
                                        this.props.details.account
                                            .accountCurrency || "€"
                                    }`}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>Luottoraja:</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>{`${formatNumber(
                                this.props.details.account.accountCreditLimit,
                                0
                            )} ${
                                this.props.details.account.accountCurrency ||
                                "€"
                            }`}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>Katevaraukset:</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>{`${formatNumber(
                                this.props.details.account
                                    .totalAuthorizationAmount,
                                2
                            )} ${
                                this.props.details.account.accountCurrency ||
                                "€"
                            }`}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>Käytettävissä:</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>{`${formatNumber(
                                this.props.details.account
                                    .accountAvailableBalance,
                                2
                            )} ${
                                this.props.details.account.accountCurrency ||
                                "€"
                            }`}</Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{ marginBottom: 8, marginTop: 8 }}
                        >
                            <Divider />
                        </Grid>
                    </Grid>
                )}
                {this.props.details && this.props.details.authorizations && (
                    <div
                        className={this.props.classes.content}
                        style={{ padding: 0 }}
                    >
                        <Grid item xs={12} style={{ marginLeft: 16 }}>
                            <Typography
                                variant="subheading"
                                style={{ fontSize: "1.2rem" }}
                            >
                                Katevaraukset
                            </Typography>
                        </Grid>
                        <AlternatingCardDetailsList>
                            <li key="authorizationDivider">
                                <Divider
                                    style={{ backgroundColor: "#004170" }}
                                />
                            </li>
                            {this.renderAuthorizations()}
                        </AlternatingCardDetailsList>
                    </div>
                )}
                {this.props.details && this.props.details.transactions && (
                    <div
                        className={this.props.classes.content}
                        style={{ padding: 0 }}
                    >
                        <Grid item xs={12} style={{ marginLeft: 16 }}>
                            <Typography
                                variant="subheading"
                                style={{ fontSize: "1.2rem" }}
                            >
                                Tapahtumat
                            </Typography>
                        </Grid>
                        <AlternatingCardDetailsList>
                            <li key={"transactionDivider"}>
                                <Divider
                                    style={{ backgroundColor: "#004170" }}
                                />
                            </li>
                            {this.renderTransactions()}
                        </AlternatingCardDetailsList>
                    </div>
                )}
            </div>
        );
    }

    renderAuthorizations = () => {
        let elements: JSX.Element[] = [];

        this.props.details &&
            this.props.details.authorizations &&
            this.props.details.authorizations.forEach((item, index) => {
                const elem = (
                    <ListItem key={index}>
                        <div className={`${this.props.classes.flexRoot}`}>
                            <span
                                className="hypodgrey hypotransactions"
                                style={{ paddingRight: 15 }}
                            >
                                {moment(item.authorizationTime).format("DD.M.")}
                            </span>
                            <span
                                className={`hypodgrey hypotransactions ${this.props.classes.flexItem}`}
                                style={{
                                    maxWidth: "calc(55% - 15px)",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    marginRight: "15px",
                                    overflow: "hidden",
                                    flex: 2,
                                }}
                            >
                                {item.merchantName}
                                {/* item.merchantCity */}
                            </span>
                            <span
                                className={`hypodgrey hypotransactions ${this.props.classes.flexItem}  ${this.props.classes.rightText}`}
                            >
                                {`-${formatNumber(
                                    item.amountInAccountCurrency,
                                    2
                                )}`}
                            </span>
                        </div>
                    </ListItem>
                );

                elements.push(elem);
            });

        return elements;
    };

    renderTransactions = () => {
        let elements: JSX.Element[] = [];

        this.props.details &&
            this.props.details.transactions &&
            this.props.details.transactions.forEach((item, index) => {
                const elem = (
                    <ListItem key={index}>
                        <div className={`${this.props.classes.flexRoot}`}>
                            <span
                                className="hypodgrey hypotransactions"
                                style={{ marginRight: 15 }}
                            >
                                {moment(item.transactionDate).format("DD.M.")}
                            </span>
                            <span
                                className={`hypodgrey hypotransactions ${this.props.classes.flexItem}`}
                                style={{
                                    maxWidth: "calc(55% - 15px)",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    marginRight: "15px",
                                    overflow: "hidden",
                                    flex: 2,
                                }}
                            >
                                {item.merchantName}
                                {/* item.merchantCity */}
                            </span>
                            <span
                                className={`hypodgrey hypotransactions ${this.props.classes.flexItem}  ${this.props.classes.rightText}`}
                                style={{
                                    color:
                                        item.creditFlag === 0
                                            ? undefined
                                            : "#00A390",
                                }}
                            >
                                {`${
                                    item.creditFlag === 0 ? "-" : "+"
                                }${formatNumber(
                                    item.amountInAccountCurrency,
                                    2
                                )}`}
                            </span>
                        </div>
                    </ListItem>
                );

                elements.push(elem);
            });

        return elements;
    };

    formatCardNumber = (number: string) => {
        const chunks = number.match(/.{1,4}/g);
        if (chunks) {
            return chunks.reduce((a, c) => `${a} ${c}`);
        }
        return number;
    };
}

const mapStateToProps = (
    state: ReduxState,
    props: ICreditCardDetailsPageProps
): ICreditCardDetailsPageStateProps => {
    const details = state.creditcard.details || [];
    const index = details.findIndex((n) => n.card.customerCardId === props.id);
    let det = undefined;
    if (index !== -1) {
        det = details[index];
    }
    return {
        details: det,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ICreditCardDetailsPageDispatchProps => {
    return {
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            return dispatch(SetShowBackNavigation(false));
        },
        GetCardDetails: async (id: string) => {
            return await dispatch(getCreditCardById(id));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CreditCardDetailsPage));



// WEBPACK FOOTER //
// ./src/views/creditcard/CreditCardDetailsPage.tsx